import React from 'react';
import clsx from 'clsx';

import styles from './Map.module.scss';
import {
	PAGE_SERP_LIST,
	MOBILE_INFOWINDOW_VIEW,
	PAGE_LANDING,
	PAGE_CALCULATE_ROUTE,
	PAGE_SERP_MAP
} from '../utils/Constants';
import { useDeviceDetection } from '../utils/DeviceDetection';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useGoogleMapsApi } from '../api/gis';
import MapResults from './MapResults';

export default function Map({
	page,
	searchParameters,
	map,
	onMapLoaded,
	results,
	focusedResult,
	onToggleInfoWindow,
	onCalcRouteClick,
	onStreetViewClick,
	onDetailClick,
	autocompleteResult
}) {
	const google = useGoogleMapsApi();
	const isMobile = useDeviceDetection();

	const [mapLatLng, setMapLatLng] = React.useState(null);
	const [mapZoom, setMapZoom] = React.useState(11);
	const [dragging, setDragging] = React.useState(false);

	React.useEffect(() => {
		if (results && results.length === 1) {
			var latLng = new google.maps.LatLng(results[0].lat, results[0].lng);
			setMapLatLng(latLng);
		}
	}, [results]);

	React.useEffect(() => {
		setMapLatLng(null);
	}, [searchParameters]);

	if (!google) return null;

	function panMapToFocusedResult(overlayView) {
		var projection = overlayView.getProjection();

		if (!projection) {
			return;
		}

		var height = 350;
		var mapDiv = map.getDiv();
		var mapHeight = mapDiv.offsetHeight;

		var latLng = new google.maps.LatLng(
			focusedResult.lat,
			focusedResult.lng
		);

		var centerPos = projection.fromLatLngToContainerPixel(map.getCenter());
		var pos = projection.fromLatLngToContainerPixel(latLng);

		// Find out how much space at the top is free
		var spaceTop = centerPos.y - height - 200;

		// Fine out how much space at the bottom is free
		var spaceBottom = mapHeight - centerPos.y;

		var needsTop = spaceTop < 0;
		var deltaY = 0;

		if (needsTop) {
			spaceTop *= -1;
			deltaY = (spaceTop + spaceBottom) / 2;
		}

		pos.y -= deltaY;
		latLng = projection.fromContainerPixelToLatLng(pos);

		if (map.getCenter() !== latLng) {
			setMapLatLng(latLng);
		}
	}

	function getStartMarkerStyle() {
		const pinURL = require('../images/pin/pin_route_start.png');
	
		return {
			icon: {
				url: pinURL,
				size: new google.maps.Size(62, 80),
				scaledSize: new google.maps.Size(31, 40),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(15, 39)
			}
		};
	}	

	return (
		<>
			{google && searchParameters ? (
				<GoogleMap
					mapContainerClassName={clsx(
						styles.root,
							page === PAGE_LANDING ||
							page === MOBILE_INFOWINDOW_VIEW
							? styles.hide
							: page === PAGE_SERP_LIST
							? styles.listView
							: null
					)}
					center={{
						lat:
							page !== PAGE_CALCULATE_ROUTE
								? mapLatLng
									? mapLatLng.lat()
									: searchParameters.lat
								: null,
						lng:
							page !== PAGE_CALCULATE_ROUTE
								? mapLatLng
									? mapLatLng.lng()
									: searchParameters.lng
								: null
					}}
					zoom={mapZoom}
					onLoad={(map) => {
						onMapLoaded(map);
					}}
					onCenterChanged={() => {
						if (map && !dragging) {
							const position = map.getCenter();
							map.panTo(position);
						}
					}}
					onDragStart={() => {
						if (!dragging) {
							setDragging(true);
						}
					}}
					onDragEnd={() => {
						if (dragging) {
							const position = map.getCenter();
							setMapLatLng(position);
							setDragging(false);
						}
					}}
					onZoomChanged={() => {
						if (map) setMapZoom(map.getZoom());
					}}
					options={{
						disableDefaultUI: true,
						noClear: true,
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						gestureHandling: 'cooperative'
					}}
				>
					<MapResults
						page={page}
						results={results}
						focusedResult={focusedResult}
						panMapToFocusedResult={panMapToFocusedResult}
						onToggleInfoWindow={onToggleInfoWindow}
						onCalcRouteClick={onCalcRouteClick}
						onStreetViewClick={onStreetViewClick}
						onDetailClick={onDetailClick}
						autocompleteResult={autocompleteResult}
					></MapResults>
					{page === PAGE_SERP_MAP && searchParameters &&
						<Marker	
							position={{
										lat: searchParameters.lat,
										lng: searchParameters.lng
									}}
							options={getStartMarkerStyle()}
						/>
					}
				</GoogleMap>
			) : null}
		</>
	);
}
